import { LinearProgress, styled } from "@mui/material";

export const StyledLinearProgress = styled(LinearProgress)`
  height: ${({ theme }) => theme.spacing(1)};
`;
